import React, { useEffect, useState } from "react";
import DoubleSelect from "../../UI/doubleSelect/DoubleSelect";
import { useAxiosGetRefreshing } from "../../../hooks/useAxios";
import { backend_routes } from "../../../common/links";
import MyLoadingIcon from "../../UI/loadingIcon/MyLoadingIcon";
import MyModal from "../../UI/modal/MyModal";
import AllForecastModalBody from "../../forecast/allForecastModalBody";

const ForecastsPageUI = function ({kind, setYear, setMonth}) {

    const [modal, setModal] = useState(false);

    const modalChange = function () {
        setModal(!modal);
    }
    const [monthsByYearMap, setMonthsByYearMap] = useState(new Map());
    const [fetchMonthsByYears, isFetchLoading] = useAxiosGetRefreshing(
        function (response) {
            setMonthsByYearMap(new Map(Object.entries(response.data.data)));
        }
    );
    useEffect(()=>{
        if (kind === "month") {
        }
        else if (kind === "day") {
            fetchMonthsByYears(backend_routes.FORECASTS_AVAILABLE_MONTHS_LINK);
        }    
    },[])
    if (kind==="month"){
        return (<select></select>);
    }
    if (kind === "day") {
        return (
            <>
            {isFetchLoading
                ?<MyLoadingIcon/>
                :<DoubleSelect map={monthsByYearMap} settingFirstCallback={setYear} settingSecondCallback={setMonth} />
            }
                <MyModal
                    visible={modal}
                    setVisible={setModal}
                    style={{ width: "50%" }}
                >
                    <AllForecastModalBody modalKind={"POST"} closeSelf={setModal} />
                </MyModal>
            </>
        );
    }
    return (<></>);
}
export default ForecastsPageUI;